import { useOutletContext } from "react-router-dom"

import type { Project } from "../types/project.types"

interface ProjectOutletContext {
  project: Project
}

export function useProjectOutletContext() {
  return useOutletContext<ProjectOutletContext>()
}
